export const cleanFileName = (fileName:any) => {
  return (fileName || '').normalize('NFD').replace(/\p{Diacritic}/gu, '').replace(/[^A-Za-z0-9_\-.]/g, '_').replace(/_+/g, '_');
}
  